import { convToHoursMins } from '../../utils/utils';

const templateCourseCard = document.createElement('template');

templateCourseCard.innerHTML = `<li class="course-card">
                                  <div class="img-holder">
                                    <img src="./logo.png" alt="">
                                    <span class="course-minutes"></span>
                                  </div>
                                  <div class="course-description">
                                    <p></p>
                                    <div class="fx name">
                                      <span></span>
                                      <button class="ml-a"></button>
                                    </div>
                                  </div>
                                </li>`;

const templatelandingCourses = document.createElement('template');

templatelandingCourses.innerHTML = `<section class="course-collection container mh-a">
                                      <span class="au-dot left"></span>
                                      <span class="au-dot right"></span>
                                      <h2 class="title">Courses</h2>
                                      <ul class="mh-a">
                                      </ul>
                                    </section>`;

export default class LandingPageCourses extends HTMLElement {
  static get observedAttributes() {
    return ['semanticname'];
  }

  set courses(value) {
    this._courses = value;
  }

  get courses() {
    return this._courses;
  }

  set semanticname(val) {
    if (val) this.setAttribute('semanticname', val);
  }

  get semanticname() {
    return this.getAttribute('semanticname');
  }

  connectedCallback() {
    this.appendChild(templatelandingCourses.content.cloneNode(true));
    // this._renderCoursesLi(this._coursesList);
  }

  attributeChangedCallback(name, oldVal, newVal) {
    if (name === 'semanticname' && newVal) {
      this._renderCoursesLi(this._coursesList);
    }
  }

  _renderCoursesLi(courses) {
    courses.forEach(element => {
      const $courseLi = templateCourseCard.content.cloneNode(true);

      $courseLi.querySelector('.name span').innerHTML = element.name;

      if (element.image)
        $courseLi
          .querySelector('.img-holder > img')
          .setAttribute('src', element.image);

      $courseLi.querySelector('.course-minutes').innerHTML = convToHoursMins(
        element.minutes
      );
      this.querySelector('.course-collection > ul').appendChild($courseLi);
    });
  }
}
